/**
 * hour, minute を hh:mm に変換
 */
export const formatTime = (hour: number, minute: number): string => {
  const hh = String(hour).padStart(2, "0");
  const mm = String(minute).padStart(2, "0");
  return `${hh}:${mm}`;
};

/**
 * hh:mm を hour, minute に変換
 */
export const parseTimeString = (
  time: string
): { hour: number; minute: number } => {
  const [hourStr, minuteStr] = time.split(":");
  return {
    hour: parseInt(hourStr, 10),
    minute: parseInt(minuteStr, 10),
  };
};

/**
 * hour, minute を Date に変換する。不正な場合 22:00 にセットしたDateを返す
 */
export const safeHourMinuteToDate = (hour: number, minute: number): Date => {
  const isValidHour = typeof hour === "number" && hour >= 0 && hour <= 23;
  const isValidMinute =
    typeof minute === "number" && minute >= 0 && minute <= 59;

  const h = isValidHour ? hour : 22;
  const m = isValidMinute ? minute : 0;

  const date = new Date();
  date.setHours(h, m, 0, 0);
  return date;
};

/**
 * date を {hour, minute} に変換する
 */
export const dateToHourMinute = (
  date: Date
): { hour: number; minute: number } => {
  const hour = date.getHours();
  const minute = date.getMinutes();
  return { hour, minute };
};
